import { FC } from 'react';
import { SortableDocumentItemProps } from './SortableDocumentItem.types';
import { Document } from '../Document';
import { useSortableItem } from '@/_hooks/useSortableItem';

export const SortableDocumentItem: FC<SortableDocumentItemProps> = ({
  document,
  documentName,
  companyId,
  exportedDocuments,
  onToggleDocument,
  onDescriptionUpdated,
}) => {
  const { attributes, listeners, setNodeRef, style } = useSortableItem(
    document.id,
  );

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <Document
        id={document.id}
        name={documentName}
        description={document.description}
        companyId={companyId}
        isChecked={document.included}
        isExported={exportedDocuments
          .map((doc) => doc.source)
          .includes(document.source)}
        needsDescription={document.needsDescription}
        onToggleDocument={onToggleDocument}
        onDescriptionUpdated={onDescriptionUpdated}
        dragListeners={listeners}
      />
    </div>
  );
};
